module.exports = __webpack_public_path__ + "media/images/form_icon-873f847779075bba619c4f5cc7940bb4.png";